<div [formGroup]="formGroup">
  <div class="row">
    @if (c.streetNum) {
      <div class="form-group col-md-3 pe-2">
        <label>{{ 'content.address.street-num' | translate }}
          <app-required [control]="c.streetNum"></app-required>
          <input class="form-control" type="text" autocomplete="on" formControlName="streetNum" #streetNumInput>
        </label>
        <app-validation-errors [displayErrors]="displayErrors" [errors]="c.streetNum.errors" [element]="streetNumInput"></app-validation-errors>
      </div>
    }
    <div class="form-group col-md-6 pe-2">
      <label>{{ 'content.address.street' | translate }}
        <app-required [control]="c.street"></app-required>
        <input class="form-control" type="text" autocomplete="on" formControlName="street" #streetInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.street.errors" [element]="streetInput"></app-validation-errors>
    </div>
    @if (c.apartmentNum) {
      <div class="form-group col-md-2 pe-2">
        <label>{{ 'content.address.unit-apt' | translate }}
          <app-required [control]="c.apartmentNum"></app-required>
          <input class="form-control" type="text" autocomplete="on" formControlName="apartmentNum" #apartmentNumInput>
        </label>
        <app-validation-errors [displayErrors]="displayErrors" [errors]="c.apartmentNum.errors" [element]="apartmentNumInput"></app-validation-errors>
      </div>
    }
  </div>
  <div class="row">
    <div class="form-group col-md-4 pe-2">
      <label>{{ 'content.address.city' | translate }}
        <app-required [control]="c.city"></app-required>
        <input class="form-control" type="text" autocomplete="on" formControlName="city" #cityInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.city.errors" [element]="cityInput"></app-validation-errors>
    </div>
    <div class="form-group col-md-4 pe-2">
      <label>{{ 'content.address.province' | translate }}
        <app-required [control]="c.province"></app-required>
        <select class="form-select" formControlName="province" #provinceInput>
          <option value=""></option>
          @for (province of provinceNames | keyvalue; track province) {
            <option value="{{ province.key }}">{{ province.value }}</option>
          }
        </select>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.province.errors" [element]="provinceInput"></app-validation-errors>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-3 pe-2">
      <label>{{ 'content.address.postal-code' | translate }}
        <app-required [control]="c.postalCode"></app-required>
        <input class="form-control" type="text" autocomplete="on" formControlName="postalCode" mask="S0S-0S0" #postalCodeInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.postalCode.errors" [element]="postalCodeInput"></app-validation-errors>
    </div>
  </div>
</div>
